import { VStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { IconMail, IconTel } from '../icons'
import { TextBodyBold1 } from '../common/Text'
import { vw } from '../../styles/theme'
import SVG from '../common/SVG'

export type NavSPGeneralContactProps = BoxProps & {}

const NavSPGeneralContact: React.FC<NavSPGeneralContactProps> = ({ ...others }) => {
  return (
    <>
      <Box {...others}>
        <VStack spacing={vw(50)}>
          <Box>
            <TextBodyBold1 localizeKey="nav__title__general_contact" color="text.200" />
          </Box>
          <Box textAlign="center">
            <TextBodyBold1 localizeKey="nav__body__general_contact_1" />
            {' ('}
            <TextBodyBold1 as="span" localizeKey="nav__body__general_contact_2" />
            {') '}
          </Box>
          <Box textAlign="center">
            <SVG svg={<IconTel />} w="15px" mr="0.5em" />
            <TextBodyBold1 localizeKey="nav__body__general_contact_3" />
          </Box>
          <Box textAlign="center">
            <SVG svg={<IconMail />} w="15px" mr="0.5em" />
            <TextBodyBold1 localizeKey="nav__body__general_contact_4" />
          </Box>
        </VStack>
      </Box>
    </>
  )
}

export default NavSPGeneralContact
